// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"545": "vendors","577": "__federation_expose_useHostAuthState",}[chunkId] || chunkId) + "-" + {"122": "2c7bfc488a4c79ca","48": "a8e14f1e98605f9a","545": "38880add7373b3a6","577": "38ae27adb57ed741",}[chunkId] + ".bundle.js"
}